import { axios } from "../../../config";

export const getUploadFiles = (queryVars) => {
  return axios.post("get-upload-files", queryVars);
};
